import React from 'react'

function HowIt() {
  return (
    <>
           {/*  How It Work End **/}
           <div className="section section-padding mt-n1">
          <div className="container">
            {/*  Section Title Start **/}
            <div className="section-title shape-03 text-center">
              <h5 className="sub-title">Over 20+ Courses</h5>
              <h2 className="main-title">
                How It <span> Work?</span>
              </h2>
            </div>
            {/*  Section Title End **/}

            {/*  How it Work Wrapper Start **/}
            <div className="how-it-work-wrapper">
              {/*  Single Work Start **/}
              <div className="single-work">
                <img
                  className="shape-1"
                  src="assets/images/shape/shape-15.png"
                  alt="Shape"
                />

                <div className="work-icon">
                  <i className="flaticon-transparency"></i>
                </div>
                <div className="work-content">
                  <h3 className="title">Find Your Course</h3>
                  <p>
                    FInd your course or module you want to learn.
                  </p>
                </div>
              </div>
              {/*  Single Work End **/}

              {/*  Single Work Start **/}
              <div className="work-arrow">
                <img
                  className="arrow"
                  src="assets/images/shape/shape-17.png"
                  alt="Shape"
                />
              </div>
              {/*  Single Work End **/}

              {/*  Single Work Start **/}
              <div className="single-work">
                <img
                  className="shape-2"
                  src="assets/images/shape/shape-15.png"
                  alt="Shape"
                />

                <div className="work-icon">
                  <i className="flaticon-forms"></i>
                </div>
                <div className="work-content">
                  <h3 className="title">Buy Course</h3>
                  <p>
                    Buy single module or bundle course (multiple modules)
                  </p>
                </div>
              </div>
              {/*  Single Work End **/}

              {/*  Single Work Start **/}
              <div className="work-arrow">
                <img
                  className="arrow"
                  src="assets/images/shape/shape-17.png"
                  alt="Shape"
                />
              </div>
              {/*  Single Work End **/}

              {/*  Single Work Start **/}
              <div className="single-work">
                <img
                  className="shape-3"
                  src="assets/images/shape/shape-16.png"
                  alt="Shape"
                />

                <div className="work-icon">
                  <i className="flaticon-badge"></i>
                </div>
                <div className="work-content">
                  <h3 className="title">Get Certificate</h3>
                  <p>
                    Get Course Complition Certificate from Techijack
                  </p>
                </div>
              </div>
              {/*  Single Work End **/}
            </div>
          </div>
        </div>
        {/*  How It Work End **/}
    
    
    </>
  )
}

export default HowIt